import { Component, OnInit } from '@angular/core';
import { TasksService } from './tasks.service';

@Component({
    selector: 'dmp-tasks-button',
    templateUrl: './tasks-button.component.html',
    styleUrls: ['./tasks-button.component.scss'],
    standalone: false
})
export class TasksButtonComponent implements OnInit {

  label: string;
  constructor(
    private tasksService: TasksService
  ) { }

  ngOnInit() {
  }

  toogle(){
    this.tasksService.toogleDisplayTasks();
  }

}
